{
  "w": 5,
  "h": 16,
  "rows": [
    ".YYY.",
    ".WWW.",
    ".KwK.",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    "..w..",
    ".WWW."
  ],
  "legend": {
    "K": "C.BLACK",
    "Y": "C.B_YELLOW",
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
